import { Controller } from "@hotwired/stimulus"
import toastr from "toastr"

export default class extends Controller {
  static targets = [];

  connect() {
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: 0,
      hideDuration: 100,
      timeOut: 5000,
      extendedTimeOut: 3000,
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut"
    };

    this.toastrInstance = this.generateToastr()
    this.toastrInstance[0]?.setAttribute("data-turbo-temporary", "true")
  }

  generateToastr() {
    let flash_key = this.data.get("key");
    let flash_value = this.data.get("value");

    switch (flash_key) {
      case "notice":
      case "success":
        return toastr.success(flash_value);
      case "info":
        return toastr.info(flash_value);
      case "warning":
        return toastr.warning(flash_value);
      case "alert":
      case "error":
        return toastr.error(flash_value);
      default:
        return toastr.success(flash_value);
    }
  }
}
